/**
 * Public-form submission for the marketing site demo request.
 * Hits POST /api/marketing-leads/demo-request, no auth required.
 */

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

export interface DemoRequestPayload {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  institution: string;
  role?: string;
  studentRange?: string;
  message?: string;
}

export async function submitDemoRequest(payload: DemoRequestPayload): Promise<void> {
  const response = await fetch(`${API_BASE}/api/marketing-leads/demo-request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = "L'envoi a échoué. Réessayez ou contactez-nous directement.";
    try {
      const data = await response.json();
      if (data?.message) {
        message = Array.isArray(data.message) ? data.message.join(' ') : data.message;
      }
    } catch {
      // ignore JSON parse error, fall back to default message
    }
    throw new Error(message);
  }
}
